module.exports = __webpack_public_path__ + "media/images/pattern_down-4b103e220e73d23b8e05c50087c5ddc3.svg";